export function capitalize(s: string): string {
  return `${s.charAt(0).toUpperCase()}${s.slice(1)}`;
}

export function truncateString(str = '', maxLength: number): string {
  return str.length > maxLength ? `${str.substring(0, maxLength)}` : str;
}

export function removeWhitespaces(str: string): string {
  return str.trim().replace(/\s+/g, '');
}

export function removeSpecialCharacters(str: string): string {
  return str.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, '');
}

export function toTitleCase(str: string): string {
  return str.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
}

export function normalizeCardType(type: string): string {
  return type.replace(/[^a-zA-Z0-9]+/gi, '').toLocaleLowerCase();
}
